<template>
    <div class="shop2_bg min-container">
        <div class="container shop_bg">
            <div class="container-con">
                <el-row>
                    <el-col :span="20">
                        <h2>Order Details</h2>
                        <div class="line" style="margin-bottom: 10px;"></div>
                    </el-col>
                    <el-col class="payment-style" :span="16">
                        <p><span class="grey-color">Nickname:</span> {{ query.nickname }}</p>
                        <p><span class="grey-color">KKTeenpatti User ID:</span> {{ query.note }}</p>
                        <p><span class="grey-color">Package:</span> {{ query.diamond }} Gold coins</p>
                        <p><span class="grey-color">Delivery:</span> {{ query.amount }} USD</p>
                        <el-checkbox v-model="checked" class="checked" @change="changeBox">Please confirm the
                            information above.
                        </el-checkbox>
                        <p class="error_tip" v-show="error_show">Please confirm the information above.</p>
                    </el-col>
                    <el-col :span="8">
                        <div class="head_img">
                            <img :src="query.headImgURL" />
                        </div>
                    </el-col>
                    <br />
                    <el-col :span="20">
                        <h2 class="payment" style="margin-top: 40px;">
                            Payment
                            <el-tooltip placement="right">
                                <div slot="content" class="tips_content" style="width: 460px;">
                                    <p style="font-size: 14px;line-height: 22px;">
                                        1、If you have any questions during the purchase process, please contact
                                        <a style="color:#ffde00;"
                                            href="mailto:info@mail.mvpstore.net">info@mail.mvpstore.net</a>
                                    </p>
                                    <p style="font-size: 14px;line-height: 22px;">2、After successful purchase, gold
                                        coins will be sent to your in-app mailbox automatically.</p>
                                </div>
                                <img style="display: inline-block;vertical-align: middle;cursor: pointer;"
                                    src="/pc/static/img/shop/tips.png" />
                            </el-tooltip>
                        </h2>
                        <div class="line"></div>
                        <el-col :span="16">
                            <el-col style="width: 25%;" class="pay-el-col" v-for="(pay, inde) in payments" :key="inde">
                                <div class="payname" :id="pay.png" :class="index === inde? 'active': ''"
                                    @click="index = inde">
                                    <img
                                        :src="'/pc/static/img/shop/' + (index === inde ? 'selected-' : '') + 'logo/' + pay.png + '.png'" />
                                </div>
                            </el-col>
                        </el-col>
                        <el-col>
                            <template v-if="index === 0">
                                <h2 class="payment" style="margin-top: 40px;">
                                    Payment Processing Provider
                                    <el-tooltip placement="right">
                                        <div slot="content" class="tips_content" style="width: 460px;">
                                            <p style="font-size: 14px;line-height: 22px;">
                                              All providers below are trustworthy and licensed online transaction processing service providers.
                                            </p>
                                        </div>
                                        <img style="display: inline-block;vertical-align: middle;cursor: pointer;"
                                            src="/pc/static/img/shop/tips.png" />
                                    </el-tooltip>
                                </h2>
                                <div class="line" style="margin-bottom: 26px"></div>
                                <ul class="sub_pay_list">
                                    <li v-for="(pay, inde) in subPayments" :key="pay.png" class='sub_pay_item'>
                                      <div v-if="(pay.png==='bitpace' )" class="payname" style="width: 140px"
                                          :style="{cursor:query.amount==='9.99'?'not-allowed':'',opacity:query.amount==='9.99'?'0.5':'1'}"
                                          :class="subIndex === inde? 'active': ''"
                                          @click="query.amount==='9.99'?null:subIndex = inde" :id="pay.png">
                                          <img
                                              :src="'/pc/static/img/shop/' + (subIndex === inde ? 'selected-' : '') + 'logo/' + pay.png + '.png'" />
                                      </div>
                                      <div v-else class="payname"
                                          style="width: 140px" :class="subIndex === inde? 'active': ''"
                                          @click="subIndex = inde" :id="pay.png">
                                          <img
                                              :src="'/pc/static/img/shop/' + (subIndex === inde ? 'selected-' : '') + 'logo/' + pay.png + '.png'" />
                                      </div>
                                    </li>
                                  </ul>
                            </template>
                        </el-col>
                        <el-col :span="24">
                            <el-button v-loading='centerDialogVisible' id="submit_button" class="submit" @click="toPayment()"></el-button>
                        </el-col>
                        <el-col :span="24">
                            <a class="return" @click.prevent="toReturn">Return</a>
                        </el-col>
                        <!-- <el-dialog :visible.sync="centerDialogVisible" :show-close="false" width="450px"
                            :append-to-body="true" :close-on-click-modal="false" top="15%" center>
                            <img class="loading_icon" src="/pc/static/img/shop/loading_icon.png" width="150px" />
                            <img class="loading_gif" src="/pc/static/img/shop/loading.gif" alt="">
                            <div style="text-align: center;font-size: 18px; margin-top:100px;">
                                <p style="margin: 0px;line-height: 26px;">{{ tips }}</p>
                            </div>
                        </el-dialog> -->
                    </el-col>
                    <el-col :span="20">

                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      checked: false,
      error_show: false,
      index: 0,
      subIndex: 0,
      payments: [],
      subPayments: [],
      centerDialogVisible: false,
      tips: ''
    }
  },
  watch: {
    index: function () {
      if (this.index === 1) {
        this.subIndex = 0
      }
    }
  },
  props: ['query', 'limitNum'],
  computed: {},
  methods: {
    toReturn () {
      this.$emit('return')
    },
    initPay () {
      this.payments = [
        {
          channel: 'crypayment',
          country: 'Global',
          payname: 'crypayment',
          png: 'crypayment',
          weight: '10000'
        }, ...this.payments]
      this.subPayments = [
        {
          channel: 'triple_a',
          country: 'Global',
          payname: 'triple_a',
          png: 'triple_a',
          weight: '9999'
        },
        {
          channel: 'epay',
          country: 'Global',
          payname: 'epay',
          png: 'epay',
          weight: '9999'
        }
        // {
        //   channel: 'bitpace',
        //   country: 'Global',
        //   payname: 'bitpace',
        //   png: 'bitpace',
        //   weight: '9999'
        // }
      ]
    },
    changeBox (newVal) {
      if (newVal) {
        this.error_show = false
      }
    },
    toPayment () {
      if (!this.checked) {
        this.error_show = true
      } else {
        // 跳转URL
        let pay = this.subPayments[this.subIndex]
        this.$axios.defaults.baseURL = process.env.VUE_APP_AXIOS
        let apiUrl = this.$axios.defaults.baseURL
        apiUrl += '/payment/pay?'
        let data = new FormData()
        data.append('uid', this.query.note)
        data.append('channel', pay.channel)
        data.append('email', this.query.email)
        data.append('goods_id', this.query.goods_id)
        data.append('from', 'mvp')
        this.centerDialogVisible = true
        this.$axios.post(apiUrl, data).then((res) => {
          console.log(res)
          let data = res.data
          if (data.code === 0) {
            window.location.href = res.data.data.PAY_URL
          } else if (data.code === -1) {
            this.$message({
              message: 'Purchase Limit Reached',
              type: 'warning',
              offset: window.innerHeight * 0.3,
              customClass: 'msg_purchase_limit'
            })
          } else {
            console.log('go else')
          }
          this.centerDialogVisible = false
        }).catch(error => {
          this.centerDialogVisible = false
          alert(error)
        })
      }
    }
  },
  created () {
    this.initPay()
    this.$store.commit('changeTab', '/shop')
  },
  mounted () {

  }
}
</script>

<style lang="scss">
.msg_purchase_limit{
  .message__icon{
    font-size: 20px;
  }
  .el-message__content{
    font-size: 20px;
  }
}

.payment-style {
    .el-checkbox {
        .el-checkbox__label {
            color: #e77900;
            font-size: 18px;
            vertical-align: middle;
            // box-shadow: 0 1px;
            line-height: 18px;
            margin: 15px 0px 15px 4px;
            padding-left: 0px;
        }

        .el-checkbox__inner {
            width: 18px;
            height: 18px;
            border-color: #aaaaaa;
        }

        .el-checkbox__inner::after {
            left: 6px;
            top: 3px;
        }

        .el-checkbox__inner::after {
            border-width: 2px;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #e77900;
        }
    }
}

.el-tooltip__popper.is-dark {
    background: #c09da3 !important;
    color: #620913;
}

.el-tooltip__popper[x-placement^=right] .popper__arrow::after {
    border-right-color: #c09da3;
}

.el-dialog__header {
    display: none;
}

.el-dialog__body {
    background-image: url("/pc/static/img/shop/loading_bg.png");
    background-position: center top;
    background-size: 100% 100%;
    background-color: #000;
    background-repeat: no-repeat;
    min-height: 225px;
    padding: 25px 40px 30px 40px;

    .loading_icon {
        position: absolute;
        top: -40px;
        left: 150px;
    }

    .loading_gif {
        position: absolute;
        bottom: 40px;
        left: 120px;
    }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.shop2_bg {
    width: 100%;
    height: 950px;
    background-image: url("/pc/static/img/hom/common_bg4.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center top;
}

.container-con {
    padding: 40px 0px 70px 0px;

    .line {
        width: 100%;
        height: 2px;
        background-image: url("/pc/static/img/shop/xian.png");
        background-position: left top;
        background-repeat: repeat;
        margin: 0px;
    }

    .line:nth-child(2) {
        margin-bottom: 26px;
    }

    .payment-style {
        p {
            line-height: 50px;
            font-size: 22px;
            margin: 0px;
        }

        .grey-color {
            color: #fade00;
        }

        .error_tip {
            line-height: 1;
            color: #ff3333;
            font-size: 16px;
            margin-top: -6px;
        }
    }

    .el-col {
        .head_img {
            margin-top: 18px;
            width: 110px;
            height: 110px;
            border-radius: 55px;
            border: 2px groove #fade00;
            overflow: hidden;

            img {
                width: 100%;
                border: #fade00 10px;
            }
        }

        h2 {
            font-size: 22px;
        }

        .payment {
            margin-top: 22px;
        }

        .sub_pay_list {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          .sub_pay_item{
            margin-right: 20px;
          }
        }

        .payname {
            width: 150px;
            height: 70px;
            overflow: hidden;
            margin-bottom: 20px;
            cursor: pointer;
            color: #fff;
            text-align: center;
            line-height: 54px;
            position: relative;

            img {
                width: 100%;
                display: inline-block;
            }

            .phase_mark {
                display: none;
                position: absolute;
                right: -1px;
                bottom: 0px;
                width: 25px;
                height: auto;
            }
        }

        .el-button.submit {
            width: 180px;
            height: 60px;
            font-size: 22px;
            color: #601b00;
            padding: 0px 20px;
            border-color: transparent;
            background-color: transparent;
            // border-radius: 2px;
            margin: 25px 0px 20px 0px;
            background-image: url(/pc/static/img/shop/buynow_nor.png);
            background-size: 100% auto;
            background-repeat: no-repeat;

            // opacity: .4;
            // cursor: not-allowed !important;
            /deep/ span {
                font-weight: 700;
            }

            &:hover {
                background-image: url(/pc/static/img/shop/buynow_selected.png);
            }
        }

        .return {
            font-size: 16px;
            color: #fff;
            box-shadow: 0 1px;
            cursor: pointer;
        }
    }
}

// @media only screen and (max-width: 1190px) {
//     .container-con .el-col .pay-el-col {
//         width: 25%;
//     }
// }

// @media only screen and (max-width: 1000px) {
//     .container-con .el-col .pay-el-col {
//         width: 33.33%;
//     }
// }

.pay-limit {
    opacity: .3;
    cursor: not-allowed !important;
    pointer-events: none
}
</style>
